var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "history" }, [
    _c("div", [
      _c(
        "div",
        { staticClass: "history__list " },
        _vm._l(_vm.items, function (item) {
          return _c("div", { staticClass: "history__item" }, [
            _vm._v(_vm._s(item.label)),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "history__info" },
        _vm._l(_vm.items, function (item) {
          return _c("div", { staticClass: "history__content" }, [
            _c("img", {
              staticClass: "history__img",
              attrs: { src: item.src, alt: "" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "history__descr" }, [
              _c("div", { staticClass: "arrows" }, [
                _c("div", { staticClass: "slider__navigation" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "slider__arrow slider__arrow--prev js-slider-prev",
                      attrs: {
                        type: "button",
                        "aria-label": "Предыдущий слайд",
                        tabindex: "0",
                      },
                    },
                    [
                      _c("span", { staticClass: "slider__arrow-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "32",
                              height: "32",
                              viewBox: "0 0 32 32",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M12.6189 15.9997L19.6095 23.038C20.1302 23.563 20.1302 24.4142 19.6095 24.9393C19.0889 25.4643 18.2448 25.4643 17.7242 24.9393L9.79101 16.9504C9.27031 16.4253 9.27031 15.574 9.79101 15.0489L17.7242 7.0601C18.2448 6.53509 19.0889 6.53509 19.6095 7.0601C20.1302 7.58511 20.1302 8.43632 19.6095 8.96132L12.6189 15.9997Z",
                                fill: "#52525B",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "slider__arrow slider__arrow--next js-slider-next",
                      attrs: {
                        type: "button",
                        "aria-label": "Следующий слайд",
                        tabindex: "0",
                      },
                    },
                    [
                      _c("span", { staticClass: "slider__arrow-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "32",
                              height: "32",
                              viewBox: "0 0 32 32",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M19.3811 16.0003L12.3905 8.96197C11.8698 8.43697 11.8698 7.58576 12.3905 7.06075C12.9111 6.53574 13.7552 6.53574 14.2758 7.06075L22.209 15.0496C22.7297 15.5747 22.7297 16.426 22.209 16.9511L14.2758 24.9399C13.7552 25.4649 12.9111 25.4649 12.3905 24.9399C11.8698 24.4149 11.8698 23.5637 12.3905 23.0387L19.3811 16.0003Z",
                                fill: "#52525B",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "history__title" }, [
                _vm._v(_vm._s(item.label)),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "history__text",
                domProps: { innerHTML: _vm._s(item.descr) },
              }),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }